import { format, isValid } from "date-fns";

const CSV_HEADERS = [
  "ID",
  "Examinee Name",
  "Examinee Email",
  "Exam Design",
  "Score",
  "Reviewed",
  "Start Time",
  "Finish Time",
  "Tags",
  "Available From",
  "Available Until",
  "Created By",
  "Created On",
];

const formatDateTime = (dateTime) => {
  if (isValid(dateTime)) {
    return format(dateTime, "yyyy-MM-dd hh:mm a");
  }
  return "";
};

const escapeCsvValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  const stringValue = String(value);
  if (/[",\n\r]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

const mapExamInstanceToCsvRow = (examInstance) => [
  examInstance.id,
  examInstance.examineeName,
  examInstance.examineeEmail,
  examInstance.examDesignName,
  examInstance.score != null ? examInstance.score.toFixed(2) : "",
  examInstance.is_reviewed ? "Yes" : "No",
  formatDateTime(examInstance.startTime),
  formatDateTime(examInstance.finishTime),
  (examInstance.tags || []).map((tag) => tag.name).join("; "),
  formatDateTime(examInstance.availableFrom),
  formatDateTime(examInstance.availableUntil),
  examInstance.createdBy,
  formatDateTime(examInstance.createdOn),
];

const buildCsvContent = (examInstances) => {
  const rows = [
    CSV_HEADERS,
    ...examInstances.map(mapExamInstanceToCsvRow),
  ];

  return rows.map((row) => row.map(escapeCsvValue).join(",")).join("\r\n");
};

/**
 * Downloads the current search results as a CSV file.
 * Columns mirror the Report and Results table.
 */
const downloadExamInstancesCsv = (
  examInstances,
  filename = "exam-instances-search-results.csv"
) => {
  const csvContent = buildCsvContent(examInstances);
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export default downloadExamInstancesCsv;
